import { createFileRoute, redirect } from "@tanstack/react-router"

// The dashboard lives at "/". `/dashboard` is the path users guess, bookmark, or
// type, so redirect it to the canonical route instead of 404ing (#69).
export const Route = createFileRoute("/dashboard")({
  beforeLoad: () => {
    throw redirect({ to: "/" })
  },
})
